// Who a vfs-service commit author is, for people: `user:<sub>` (or `user:user:<sub>` as `git show` prints it) →
// the person's name / email from the project's people (its owner and members, GET /access; the people of
// /collab/activity), else a short form of the id. An agent working for nobody (`mcp:<project>`) is "AI agent".
import { subOfAuthor } from './commitDiffParser';

/** `sub` → `{ sub, name, email }`, from an access answer (`{ owner, members }`) and the people of the activity. */
export function peopleBySub(access, activityPeople = []) {
  const known = new Map();
  for (const person of [access?.owner, ...(access?.members || [])]) {
    if (person && person.sub) { known.set(String(person.sub), { sub: String(person.sub), name: person.name || '', email: person.email || '' }); }
  }
  for (const person of activityPeople || []) {
    const sub = person && (person.sub || subOfAuthor(person.id));
    // vfs-service falls back to the sub itself as the name of someone it does not know: not a name.
    if (!sub || known.has(String(sub)) || !person.name || String(sub).startsWith(person.name)) { continue; }
    known.set(String(sub), { sub: String(sub), name: person.name, email: person.email || '' });
  }
  return known;
}

/**
 * `{ name, email, id, known }` for an author id (`user:<sub>`, `user:user:<sub>`, `mcp:<project>`, …); `name` is
 * what to show: the person's name, else their email, else their account id (`<sub>`, shortened), else the id.
 */
export function actorDisplay(actorId, people) {
  const id = String(actorId || '');
  const sub = subOfAuthor(id);
  const person = sub && people ? people.get(sub) : null;
  if (person && (person.name || person.email)) {
    return { name: person.name || person.email, email: person.email, id, known: true };
  }
  if (/^(?:agent:)?mcp:/.test(id)) { return { name: 'AI agent', email: '', id, known: false }; }
  // Someone the project lists with no name nor email, or does not list: their account id without `user:`, as the
  // Activity rows show them (vfs-service collab/people.js authorOf), never the raw `user:<sub>`.
  if (sub) { return { name: sub.length > 24 ? `${sub.slice(0, 24)}…` : sub, email: '', id, known: false }; }
  return { name: id || 'Unknown', email: '', id, known: false };
}
